import { ERROR_MESSAGES, HTTP_STATUS } from '../config/qbConstants';

// Handle QuickBooks API errors with specific messaging
export const handleQBApiError = (error, context = '') => {
  console.error(`Error in ${context}:`, error);
  
  // Provide more specific error messages based on status
  if (error.response?.status === HTTP_STATUS.UNAUTHORIZED) {
    throw new Error(ERROR_MESSAGES.QB_CONNECTION_EXPIRED);
  } else if (error.response?.status === HTTP_STATUS.NOT_FOUND) {
    if (context.includes('customer')) {
      throw new Error(ERROR_MESSAGES.QB_NO_CONNECTION);
    } else if (context.includes('pdf')) {
      throw new Error(ERROR_MESSAGES.QB_PDF_NOT_FOUND);
    }
    throw new Error(ERROR_MESSAGES.QB_NO_CONNECTION);
  } else if (error.response?.data?.message) {
    throw new Error(error.response.data.message);
  } else {
    if (context.includes('customer')) {
      throw new Error(ERROR_MESSAGES.QB_CUSTOMERS_FETCH_FAILED);
    }
    throw error;
  }
};

// Handle OAuth token errors
export const handleTokenError = (error, operation) => {
  console.error(`Error in ${operation}:`, error);
  
  if (operation === 'refresh') {
    throw new Error(ERROR_MESSAGES.QB_TOKEN_REFRESH_FAILED);
  }
  
  throw error;
};

// Handle invoice PDF errors
export const handlePDFError = (error) => {
  console.error('Error downloading invoice PDF:', error);
  
  if (error.response?.status === HTTP_STATUS.NOT_FOUND) {
    throw new Error(ERROR_MESSAGES.QB_PDF_NOT_FOUND);
  } else if (error.response?.status === HTTP_STATUS.UNAUTHORIZED) {
    throw new Error(ERROR_MESSAGES.QB_PDF_CONNECTION_EXPIRED);
  }
  
  throw error;
};